import React, { useState } from "react";
import { CategoryDetails } from "../../../../../shared/services/interface";
import InputBox from "../../../components/InputBox";
import { Button } from "src/business-types/grocery/components/Button";
import { patchCategory } from "../../../../../shared/services/services";
import { notifyError, notifySuccess } from "../../../../../assets/toastService";
import PopupModules from "src/features/auth/components/PopupModules";
import { errorHandling } from "src/shared/services/errorHandling";

type Props = {
  editData: CategoryDetails;
  close: (data: any) => void;
  loading: (isLoading: boolean) => void;
  editCategory: boolean;
};

const EditCategory: React.FC<Props> = ({ editData, close, loading, editCategory }) => {
  const [categoryName, setCategoryName] = useState(editData.CategoryName.trim());
  const [categorySecondName, setCategorySecondName] = useState(editData.categorySecondName?.trim() || "");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleUpdate = async () => {
    const trimmedName = categoryName.trim();
    if (!trimmedName) return notifyError("Category name cannot be empty.");

    // Prevent duplicate submissions
    if (isSubmitting) return;

    try {
      setIsSubmitting(true);
      loading(true);

      const update = {
        CategoryName: trimmedName,
        categorySecondName: categorySecondName.trim(),
      };
      const response = await patchCategory(update, editData._id.$oid);

      notifySuccess("Category updated successfully!");
      close(response);
    } catch (error: any) {
      errorHandling(error);
    } finally {
      setIsSubmitting(false);
      loading(false);
    }
  };

  const handleClose = () => close("");

  return (
    <PopupModules isOpen={editCategory} onClose={handleClose} title='Edit Category'>
      <div className='flex flex-col gap-3 m-3'>
        <label className='text-sm font-medium text-gray-700 px-1'>Category Name</label>
        <InputBox maxLength={20} value={categoryName} onChange={(e) => setCategoryName(e.target.value)} placeholder='Enter new category name' />
        <label className='text-sm font-medium text-gray-700 px-1'>Second Name</label>
        <InputBox
          maxLength={20}
          value={categorySecondName}
          onChange={(e) => setCategorySecondName(e.target.value)}
          placeholder='Enter new Second Name'
        />

        <div className='flex justify-center gap-3 mt-3'>
          <Button label='Cancel' variant='ThemeCancel' className='border' onClick={handleClose} />
          <Button
            label={isSubmitting ? "Updating..." : "Update"}
            variant='ThemeBase'
            onClick={handleUpdate}
            disabled={
              isSubmitting ||
              !categoryName.trim() ||
              (categoryName.trim() === editData.CategoryName.trim() && categorySecondName.trim() === (editData.categorySecondName?.trim() || ""))
            }
          />
        </div>
      </div>
    </PopupModules>
  );
};

export default EditCategory;
